import { AccountStatus, SortOrder } from '../../types';
import {
  QuarterlyRevenueAccount,
  QuarterlyRevenueAccountSummary,
} from '../../types/quarterlyRevenue';

export const quarterlyRevenueStoreKey = 'quarterlyRevenue';

export interface QuarterlyRevenueState {
  accounts: QuarterlyRevenueAccount[];
  loading: boolean;
  error?: null | {
    message: string;
  };
  sortBy: SortAccountsBy;
  sortQuarterlyRevenueBy: SortQuarterlyRevenueBy;
  quarterlyRevenueSortOrder: SortOrder;
  sortOrder: SortOrder;
  dateFilterValue: string | null;
  dateFilterValueLocal: string | null;
  accountListFetchErrorMessage?: string | null;
  filters: RevenuePageFilters;
  accountsList: QuarterlyRevenueAccountSummary[];
  projectAndAccountListLoading: boolean;
  currentPage: number;
  pageSize: number;
  totalPages: number;

  isUniqueFilterListsDefined: boolean;
  uniqueFilterLists: {
    pdms: { value: string; label: string }[];
    dms: { value: string; label: string }[];
  };
}

export interface AppStateWithQuarterlyRevenueStateData {
  [quarterlyRevenueStoreKey]: QuarterlyRevenueState;
}

export interface AccountsSortPayloadType {
  sortBy: SortAccountsBy;
  sortOrder?: SortOrder;
}
export interface QuarterlyRevenueSortPayloadType {
  sortBy: SortQuarterlyRevenueBy;
  sortOrder?: SortOrder;
}

export enum SortAccountsBy {
  AccountName = 'Account name',
  RevenueStatus = 'Revenue status',
  ClientGrowth = 'Client growth',
  AeRevenueDecreaseReasons = 'AE revenue decrease reasons',
  Headcount = 'Headcount',
  PDM = 'PDM',
  DM = 'DM',
  // Used only by the merged "PDM / DM" column shown on narrower screens.
  PDMAndDM = 'PDM / DM',
}

export enum SortQuarterlyRevenueBy {
  Quarter = 'Quarter',
  RevenueStatus = 'Revenue status',
  ClientGrowth = 'Client growth',
  AeRevenueDecreaseReasons = 'AE revenue decrease reasons',
  Headcount = 'Headcount',
}

export enum GroupAccountsBy {
  AccountName = 'Account Name',
  ClientPartner = 'Client partner',
  PortfolioDeliveryManager = 'PDM',
  DeliveryManager = 'DM',
}

export interface RevenuePageFilters {
  accountStatus: AccountStatus | null;
  nextQRevenueStatus: string;
  clientGrowth: string;
  hcDeltaType: string;
  PDMsToFilter: string[];
  DMsToFilter: string[];
  currentPage: number;
  pageSize: number;
}

export enum FilterAccountsBy {
  PortfolioDeliveryManager = 'PDM',
  DeliveryManager = 'DM',
  ClientPartner = 'CP',
}
export interface GetRevenuePagePayloadType {
  currentPage?: number;
  pageSize?: number;
}
